import path from "path";

import { copy, pathExists, readFile } from "fs-extra";

import { ILogger } from "../../Commons/Logging/ILogger";
import { getLogger } from "../../Commons/Logging/StaticLogger";
import { BuildCache, FormBuildCacheOptions } from "../../FormWebpackConfiguration/CacheAssetsPlugin";

export async function writeAttachmentPathByGfvFiles(
    gfv: string,
    formPath: string,
    resourcesDirectory: string,
    parentLogger: ILogger = getLogger(),
    buildCache?: BuildCache,
    buildCacheOptions?: FormBuildCacheOptions
): Promise<void> {
    const sourceFile = path.join(formPath, "form", "AttachmentPathsWithGfvs.json");
    const targetFile = path.join(resourcesDirectory, "attachmentpathswithgfvs", `${gfv}.json`);

    if (!(await pathExists(sourceFile))) {
        return;
    }

    const logger = parentLogger.withPrefix(`ATTACHPATHBYFGV:${gfv}`);
    logger.log(`copy\n  from: ${sourceFile}\n  to:   ${targetFile}`);
    await copy(sourceFile, targetFile);

    if (buildCache != undefined && buildCacheOptions != undefined) {
        await buildCache.setContent(
            buildCacheOptions.generatorVersion,
            buildCacheOptions.gfv,
            buildCacheOptions.depsHash,
            path.join("attachmentpathswithgfvs", `${gfv}.json`),
            await readFile(sourceFile, "utf-8")
        );
    }
}
